// Parse message from old REST API format
export const parseCampaignMessage = (message, username) => {
  const newMessage = {
    id: message.id,
    senderId: message.sender_id,
    senderType: message.sender_type,
    username: message.sender_username,
    campaignId: message.campaign_id,
    message: message.message,
    createdDate: message.created_at,
    updatedAt: message.updated_at,
    attachmentUrl: message.attachments_url,
    isMy: username === message.sender_username,
    isSms: message.sender_type === 'admin|sms' || message.sender_type === 'user|sms',
  };

  return newMessage;
};

// Parse message from GraphQL API
export const parseCampaignMessageGraphQL = (message, username) => {
  const newMessage = {
    id: message.id,
    senderId: message.senderId,
    senderType: message.senderType,
    username: message.senderUserName,
    campaignId: message.campaignId,
    message: message.message,
    createdDate: message.createdDate,
    updatedAt: message.createdDate, // GraphQL doesn't have updatedAt
    attachmentUrl: message.attachmentUrl,
    messageRead: message.messageRead,
    readDate: message.readDate,
    senderTypeName: message.senderTypeNavigation?.typeName,
    messageTypeName: message.messageType?.typeName,
    isMy: username === message.senderUserName,
    isSms: false, // Will be determined by messageType if needed
    isFromTerraboost: message.senderType === 145,
    isFromCustomer: message.senderType !== 145,
  };

  return newMessage;
};
